module.exports = __webpack_public_path__ + "img/1.d21979af.png";